/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Unavailable_CloseInputs */



/**
* | output |
* | --- |
* | "OK" |
*
* @param {Demo_Unavailable_CloseInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const demo_unavailable_close = /** @type {((inputs?: Demo_Unavailable_CloseInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Unavailable_CloseInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oké")
	if (locale === "fr") return /** @type {LocalizedString} */ ("D'accord")
	return /** @type {LocalizedString} */ ("OK")
});